@if (online() === false) {
  <div class="offline" @fadeIn @fadeOut>
    <div class="text-xs text-neutral-900 mb-20 bg-white rounded-md px-2.5 py-1.5 flex flex-row items-center">
      <app-spinner></app-spinner>
      You are offline. Trying to reconnect...
    </div>
  </div>
}
